import { apiSlice } from './apiSlice';

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Login
    login: builder.mutation<
      {
        success: boolean;
        data: { access_token: string; refresh_token: string; token_type: string };
        message?: string;
      },
      {
        username: string;
        password: string;
        // captchaId: string;
        // captchaText: string;
      }
    >({
      query: (body) => ({
        url: '/login',
        method: 'POST',
        body,
      }),
    }),

    //logout
    logout: builder.mutation<any, void>({
      query: () => ({
        url: '/auth/logout',
        method: 'POST',
      }),
    }),

    // new captcha endpoint
    getCaptcha: builder.query<any, void>({
      query: () => ({
        url: '/captcha',
        method: 'POST',
      }),
    }),
    getUser: builder.query<any, void>({
      query: () => ({ url: '/users/me', method: 'GET', params: { ts: Date.now() } }),
      providesTags: ['Auth'],
    }),
  }),
});

export const {
  useGetCaptchaQuery,
  useLazyGetCaptchaQuery,
  useLoginMutation,
  useLogoutMutation,
  useGetUserQuery,
} = authApi;
